import React, { createContext, useContext } from 'react';
import { auth, db, storage } from './config';

const FirebaseContext = createContext();

export function FirebaseProvider({ children }) {
  const value = {
    auth,
    db,
    storage
  };

  return (
    <FirebaseContext.Provider value={value}>
      {children}
    </FirebaseContext.Provider>
  );
}

export function useFirebase() {
  const context = useContext(FirebaseContext);
  if (context === undefined) {
    throw new Error('useFirebase must be used within a FirebaseProvider');
  }
  return context;
} 